export const ARTICLE_ID = 'GDPR-POPUP';
export const GDPR_POPUP = 'gdpr_popup';
export const GDPR_POPUP_VISIBLE = 'gdpr_popup_visible';
